module.exports = __webpack_public_path__ + "img/basketball_logo.b237dcc6.svg";